
import { supabase } from '@/integrations/supabase/client';

export const updateOrganizationPhoneVerification = async (
  email: string, 
  phoneNumber: string
): Promise<{ success: boolean; error?: string }> => {
  try {    
    // Update organization phone verification status
    const { data, error } = await supabase
      .from('organisations')
      .update({
        poc_phone: phoneNumber,
        poc_phone_verified: true
      })
      .eq('poc_email', email)
      // Every onboarding state (was status draft/submitted before FIG-345 UC-225).
      // filter(): the generated types predate onboarding_state (in() on it hits TS2589).
      .filter('onboarding_state', 'in', '(not_started,in_progress,submitted)')
      .select('id, name, onboarding_state')
      .maybeSingle();

    if (error) {
      console.error('[updateOrganizationPhoneVerification] Error updating organization:', error);
      return { success: false, error: error.message };
    }
    return { success: true };
  } catch (error: any) {
    console.error('[updateOrganizationPhoneVerification] Unexpected error:', error);
    return { 
      success: false, 
      error: error instanceof Error ? error.message : 'Unknown error occurred' 
    };
  }
};
